<template>
  <el-container direction='vertical'>
    <router-view></router-view>
  </el-container>
</template>
<script>
export default {
  name: 'Public',
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>
<style lang="less">
</style>



// WEBPACK FOOTER //
// src/views/mobile/PublicApp/Public.vue